
import ThirdwebWrapper from "./components/ThirdwebWrapper";
import "process/browser";
import WalletConnect from "./components/walletConnect";
import React from "react";
import './index.css';

function App() {
  return (
      <ThirdwebWrapper>
        <WalletConnect />
      </ThirdwebWrapper>
  );
}

export default App;
